export const NOTIFICATIONS_MESSAGE_TYPES = {
  error: "ERROR",
  info: "INFO",
  success: "SUCCESS",
  cancel: "CANCEL",
};
